<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      v-if="showForm.basic"
      :close-on-click-modal="false"
      title="评价记录详情"
      width="500"
      @close="close"
    >
      <el-row>
        <el-col :span="5">支付人:</el-col>
        <el-col :span="19">
          <el-avatar shape="square" :size="32" :src="showForm.basic.profile.avatar"></el-avatar>
          <div>{{ showForm.basic.profile.name }}</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">设备标题:</el-col>
        <el-col :span="19">{{ showForm.basic.deviceTitle }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">支付标题:</el-col>
        <el-col :span="19">{{ showForm.basic.paymentTitle }}</el-col>
      </el-row>
      <el-row>
        <el-col :span="5">支付价格:</el-col>
        <el-col :span="19">
          {{ showForm.basic.price }}
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">时长:</el-col>
        <el-col :span="19">
          {{ showForm.basic.duration }}分钟
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">支付时间:</el-col>
        <el-col :span="19">
          {{ moment(showForm.created).format('YYYY-MM-DD HH:mm:ss') }}
        </el-col>
      </el-row>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { findPaymentRecord } from '@/api/alfmeier'
export default {
  name: 'AlfmeierPaymentRecordDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      row: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const paymentRecordId = row.paymentRecordId
      this.row = row
      const data = await findPaymentRecord({
        paymentRecordId,
      })
      this.showForm = data
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
